import {
  BUTTON,
  CLOSE_BUTTON,
  CONTAINER,
  FULLSCREEN,
  IMAGE,
  NUMBER_PICKER,
  POLL,
  POLL_OPTION,
  QUIZ_OPTION,
  SCROLL_CONTAINER,
  SLIDER,
  STANDARD,
} from './constants.js';

export const is = {
  widget: {
    containerType: isProperty('type', CONTAINER),
    buttonType: isProperty('type', BUTTON),
    closeRole: isProperty('role', CLOSE_BUTTON),
    imageType: isProperty('type', IMAGE),
    poll: isProperty('type', POLL),
    pollOption: isProperty('type', POLL_OPTION),
    voteButton: isProperty('role', POLL_OPTION),
    quizButton: isProperty('role', QUIZ_OPTION),
    scrollContainer: isProperty('type', SCROLL_CONTAINER),
    quizOption: isProperty('type', QUIZ_OPTION),
    numberPicker: isProperty('type', NUMBER_PICKER),
    slider: isProperty('type', SLIDER),
  },
  slideDisplayMode: {
    fullscreen(slide) {
      return slide._displayMode === FULLSCREEN;
    },
    standard(slide) {
      return slide._displayMode === STANDARD;
    },
  },
};

function isProperty(propertyName, expected) {
  return (widget) => {
    try {
      const actual =
        typeof widget[propertyName] === 'string'
          ? widget[propertyName]
          : widget[`_${propertyName}`];
      return actual === expected;
    } catch (exception) {
      console.error(exception);
    }
  };
}
